import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useNotifications, NOTIFICATION_ROUTES, getColor, getBadges } from '@/hooks/useNotifications';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { animate, AnimatePresence, motion } from 'framer-motion';
import { useHistory } from 'react-router-dom';

dayjs.extend(relativeTime);

const Notifications = () => {
  const history = useHistory();
  const { notifications, unreadCount, markAsRead, markAllAsRead, subscribeToPush } = useNotifications();

  const handleNotificationClick = (notification) => {
    markAsRead(notification._id);
    const route = NOTIFICATION_ROUTES[notification.notificationType];
    if (route) {
      // Pass relatedData as router state so the destination page can open
      // the correct task drawer or AI alert panel automatically.
      history.push({
        pathname: route,
        state: {
          alertId: notification.relatedData?.alertId,
          taskId: notification.relatedData?.taskId,
        },
      });
    }
  };

  // getColor and getBadges are now imported from useNotifications hook

  return (
    <div className="notifications whiteBox shadow">
      <div className="pad10" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <p className="strong">Notifications ({unreadCount})</p>
        <div>
          <Button type="link" size="small" onClick={markAllAsRead}>
            Mark all as read
          </Button>
          <Button type="link" size="small" onClick={subscribeToPush}>
            Enable Push
          </Button>
        </div>
      </div>
      <div className="line"></div>
      <div className="notif-list" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {notifications.length === 0 ? (
          <div className="pad10 text-center">No notifications</div>
        ) : (
          notifications.map((n) => {
            const badges = getBadges(n);
            return (
              <div
                key={n._id}
                className={`notification ${n.isRead ? 'read' : 'unread'}`}
                style={{
                  padding: '12px 16px',
                  borderBottom: '1px solid #f0f0f0',
                  cursor: 'pointer',
                  backgroundColor: n.isRead ? 'transparent' : '#f0faff',
                  borderLeft: `4px solid ${getColor(n)}`,
                  transition: 'all 0.3s'
                }}
                onClick={() => handleNotificationClick(n)}
              >
                <div style={{ fontWeight: n.isRead ? '500' : '700', fontSize: '14px', marginBottom: '2px' }}>{n.title}</div>
                <div style={{ fontSize: '13px', color: '#444', lineHeight: '1.4' }}>{n.message}</div>

                {badges.length > 0 && (
                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '8px' }}>
                    {badges.map((badge, idx) => (
                      <span
                        key={idx}
                        style={{
                          display: 'inline-block',
                          padding: '1px 8px',
                          borderRadius: '4px',
                          fontSize: '10px',
                          fontWeight: 'bold',
                          backgroundColor: badge.bgColor || badge.color,
                          color: badge.textColor || '#ffffff',
                          border: badge.borderColor ? `1px solid ${badge.borderColor}` : 'none'
                        }}
                      >
                        {badge.text}
                      </span>
                    ))}
                  </div>
                )}

                <div style={{ fontSize: '11px', color: '#999', marginTop: '6px' }}>
                  {dayjs(n.createdAt).fromNow()}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};
export default Notifications;
